import services from 'services/services';
import * as types from '../types';

// Import helpers
import { checkFetchErrors } from '../helpers_actions/convert_helpers';

// ******************** FETCH CHANNELS_PLATFORMS TO EDIT ********************
export const fetchChannelsPlatforms = (channelId) => async (dispatch) => {
	try {
		// Dispatch a loading action
		dispatch({
			type: types.FETCH_CHANNELS_PLATFORMS_LOADING,
			payload: true
		});

		const { data } = await services.get(
			`products/channels/${channelId}/platformFields`
		);

		// Dispatch an action with data
		dispatch({
			type: types.FETCH_CHANNELS_PLATFORMS_SUCCESS,
			payload: data
		});
	} catch (error) {
		dispatch({
			type: types.FETCH_CHANNELS_PLATFORMS_ERROR,
			payload: checkFetchErrors(error)
		});
	}
};
